import React from 'react';
import { SettingsPage } from '../../components/SettingsPage/SettingsPage';
import { SettingsCategory } from '../../config/SettingsCategory';
import { useSettingsPage } from '../../hooks/useSettingsPage';
import { SettingsRenderer } from '../../SettingsProvider/SettingsRenderer';
import './TLSSettingsPage.css';
import { TLS_SETTING_IDS } from '../../config/SettingIds';

export interface TLSSettingsPageProps {
	onNavigatingBack: () => void;
}

export const TLSSettingsPage: React.FC<TLSSettingsPageProps> = ({ onNavigatingBack }) => {
	const { settingsState, availableSettingIds, handleChangeBySettingId, restoreDefaults } =
		useSettingsPage({
			category: SettingsCategory.TLS,
			revertOnError: true,
		});
	// Filter only TLS-related settings for this page
	const tlsSettingIds = TLS_SETTING_IDS
		? Object.values(TLS_SETTING_IDS).filter((settingId) =>
				availableSettingIds.includes(settingId)
			)
		: [];

	return (
		<SettingsPage
			canNavigateBack={!!onNavigatingBack}
			onNavigatingBack={onNavigatingBack}
			title="TLS"
			showRestoreDefaults={true}
			onRestoreDefaults={restoreDefaults}
			settings={
				<div className="tls-settings-page">
					{/* Dynamically render all TLS settings */}
					{tlsSettingIds.map((settingId) => (
						<SettingsRenderer
							key={settingId}
							settingId={settingId}
							settingsState={settingsState}
							handleChange={handleChangeBySettingId}
						/>
					))}
				</div>
			}
		/>
	);
};
